import React from 'react';
import { Grid, Row, Col } from "react-bootstrap";
import products, { featuredProduct } from '../data/products';
import './Product.css';

function ExternalLink({ href, children }) {
  return <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
}

function ProductCard({ product, colProps }) {
  const toggleId = `product-${product.key}`;
  return (
    <Col className="Card" md={4} sm={12} {...colProps}>
      <input type="checkbox" id={toggleId} />
      <div className="react-card-flip">
        <label htmlFor={toggleId}>
          <div className="react-card-flipper">
            <div className="react-card-front">
              <div className="thumbnail">
                <img src={product.image} alt={product.title} />
                <div className="caption">
                  <h3>
                    {product.link ? <ExternalLink href={product.link}>{product.title}</ExternalLink> : product.title}
                  </h3>
                </div>
              </div>
            </div>
            <div className="react-card-back">
              <div className="description">
                <h3>{product.backTitle || product.title}</h3>
                <p>{product.description}</p>
                {product.link &&
                  <p className="text-center">
                    <ExternalLink href={product.link}>{product.linkLabel}</ExternalLink>
                  </p>
                }
              </div>
            </div>
          </div>
        </label>
      </div>
    </Col>
  );
}

export default function Product() {
  return (
    <Grid>
      <Row className="Product">
        <ProductCard product={featuredProduct} colProps={{ mdOffset: 4 }} />
      </Row>
      <Row className="Product">
        {products.map(product => <ProductCard key={product.key} product={product} />)}
      </Row>
    </Grid>
  );
}



// WEBPACK FOOTER //
// ./src/components/Product.js